import * as React from "react";
import { connect, DispatchProp } from "react-redux";

import { Image as ImageEntity } from "../../entities";
import { RootState, SubAppState } from "../../state";
import Image, { ImageProps } from "../../common/components/Image";

type OwnProps = {
  namespace?: keyof SubAppState;
  id: EntityId;
} & ImageProps &
  DispatchProp<any>;

interface MappedProps {
  image?: ImageEntity;
}
type Props = OwnProps & MappedProps;

const ImageContainer: React.SFC<Props> = ({ namespace: _namespace, id: _id, dispatch: _dispatch, ...rest }) => {
  return <Image {...rest} />;
};

ImageContainer.defaultProps = {
  x2: true,
  background: false,
};

function mapStateToProps(state: RootState, props: OwnProps): MappedProps {
  const scope = props.namespace ? state[props.namespace] : state;
  return {
    image: (scope.entities as any).images[props.id] as ImageEntity,
  };
}

export default connect(mapStateToProps)(ImageContainer);



// WEBPACK FOOTER //
// ./frontend/src/common/components/ImageContainer.tsx